<script>
  export default {
    props: {
      item: {
        type: Object,
        default: () => {
          return {}
        },
      },
    },
    data() {
      return {
       
      }
    },
    methods: {
      goToView(item) {
        if(item.to) {
          this.$router.push(item.to)
        } else {
          window.open(item.href, '_blank');
        }
      },
    }
  }
</script>
<template>
  <div :class="$style.Box">
    <div class="Box__block" @click="goToView(item)">
      <div class="Box__blockInner">
        <div
          v-if="item.icon"
          class="Box__icon"
          :class="item.iconClass"
          v-html="item.icon"
        ></div>
        <div
          v-else
          :class="item.iconClass"
          class="Box__icon"  
        >
          <img :src="item.img" alt="">
        </div>
        <div class="Box__title">{{ item.name || item.text }}</div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" module>
  .Box {
    :global {
      .Box {
        &__block {
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 100%;
          padding-top: 100%;
          cursor: pointer;
          cursor: pointer;
          // border: 1px solid #C6C6BA;
          box-shadow: 0px 2px 6px rgba(33, 69, 88, 0.09);
          border-radius: 5px;
          transition: .3s;
          background: #fff;
        }

        &__blockInner {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 100%;
          text-align: center;
          // text-indent: 0.25em;
          transform: translate(-50%, -50%);
        }

        &__icon {
          width: 60px;
          height: 60px;
          margin: 0 auto;
          font-size: 60px;
          color: #4D5561;
          background-position: center;
          background-size: cover;
          transition: .3s;

          @include max-md {
            width: 50px;
            height: 50px;
            font-size: 40px;
          }
          &.about {
            line-height: 50px;
            img {
              width: 33px;
            }
          }
        }

        &__title {
          font-size: 1.25rem;
          transition: .3s;
          margin-top: 0.875rem;
          @include max-md {
            font-size: 0.87125rem;
          }
        }
      }
    }
    &:global {
      &.isStyleNoShadow {
        .Box {
          &__block {
            box-shadow: none;
          }
        }
      }
      &.isStyleLong {
        .Box {
          &__block {
            padding-top: 32%;
          }
          &__icon {
            font-size: 34px;
            img {
              
            }
          }
          &__title {
            margin-top: 10px;
          }
        }
      }
      &.socialMenu {
        .Box__icon {
          line-height: 75px;
          letter-spacing: 0;
          width: 75px;
          height: 75px;
          border: 1px solid $color-primary;
          border-radius: 50%;
          @include max-sm {
            font-size: 25px;
            width: 60px;
            height: 60px;
            line-height: 60px;
          }
        }
      }
    }
  }
</style>
